/* eslint-disable no-undef */

export const getBrowserLanguage = () => navigator.language?.slice(0, 2);

const getLocalStorageLanguage = () => localStorage.getItem('language');

// Only the languages with a catalogue here; any other browser language gets the Italian one.
const SUPPORTED_LOCALES = ['it', 'en'];

export const getLocale = () =>
  [getLocalStorageLanguage(), getBrowserLanguage()].find((locale) =>
    SUPPORTED_LOCALES.includes(locale)
  ) || 'it';

const getTranslations = (trnsl = {}) => {
  const req = require.context('./', true, /\.json.*$/);
  const translations = {};

  req.keys().forEach((file) => {
    const locale = file.replace('./', '').replace(/\.js(on)?$/, '');
    // No plural-rules locale data is loaded here any more: `Intl.PluralRules` is
    // native in every browser this build targets, so react-intl uses the engine's.
    translations[locale] = {
      ...req(file),
      ...trnsl,
    };
  });
  return translations;
};

export const getMessages = (translations = []) =>
  getTranslations(translations)[getLocale()] || {};

export const getForcedMessages = (language) =>
  getTranslations()[language] || {};
